import React from "react";

import ModuleChildrenTreePanel from "../definition-editor/ModuleChildrenTreePanel";
import DesignerLibraryPanel from "./DesignerLibraryPanel";

function LeftTabButton({ active, children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex-1 px-3 py-2 text-sm border-b-2 transition",
        active
          ? "bg-white border-blue-600 text-blue-700 font-medium"
          : "bg-slate-50 border-transparent text-slate-500 hover:text-slate-800",
      ].join(" ")}
    >
      {children}
    </button>
  );
}

export default function EditorLeftPanel({
  activeTab,
  onChangeTab,

  resolvedNodes = [],
  selectedId,
  onSelectNode,
  onOpenNode,
  onAddChild,

  definitions = [],
  templates = [],
  onAddDefinition,
  onAddTemplate,
}) {
  return (
    <aside className="min-h-0 overflow-hidden border-r bg-white flex flex-col">
      <div className="h-11 shrink-0 border-b bg-slate-50 flex">
        <LeftTabButton
          active={activeTab === "browser"}
          onClick={() => onChangeTab?.("browser")}
        >
          Scene
        </LeftTabButton>

        <LeftTabButton
          active={activeTab === "library"}
          onClick={() => onChangeTab?.("library")}
        >
          Add
        </LeftTabButton>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden">
        {activeTab === "browser" ? (
          <div className="h-full min-h-0 overflow-auto">
            <ModuleChildrenTreePanel
              nodes={resolvedNodes}
              selectedId={selectedId}
              onSelect={onSelectNode}
              onOpen={onOpenNode}
              onAddChild={onAddChild}
            />
          </div>
        ) : (
          <DesignerLibraryPanel
            definitions={definitions}
            templates={templates}
            onAdd={onAddDefinition}
            onAddTemplate={onAddTemplate}
          />
        )}
      </div>
    </aside>
  );
}